import React,{useEffect} from 'react';
import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import Homepage from './homepage/screens/Homepage/Homepage.jsx';
import ComingLater from './comingsoon/screens/ComingLater/ComingLater.jsx';
import Bcher from './bookchoice/screens/Bcher/Bcher.jsx';
import Reading12 from './reading12option/screens/Reading/Reading.jsx';
import ReadingFreechoice from "./readingfreechoice/screens/ReadingFreechoice/ReadingFreechoice.jsx"
import Landingpage from './landingpage/screens/landingpage/landingpage.jsx';
import Explanation from './explanation/screens/explanation/Explanation.jsx';
import Imprint from './imprint/screens/imprint/Imprint.jsx';

import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: "AIzaSyAAT97ZFuVUU5bGOVfq7G06dT8wU44plP4",
  authDomain: "weread-45736.firebaseapp.com",
  projectId: "weread-45736",
  storageBucket: "weread-45736.appspot.com",
  messagingSenderId: "810813848415",
  appId: "1:810813848415:web:e188efbb0cba22179654ea",
  measurementId: "G-GDLYPSSVF3"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
export const analytics = getAnalytics(app);

function App() {
  return (
    <Router>
      <Routes>
      <Route path="/imprint" element={<Imprint />} />
        <Route path="/explanation" element={<Explanation />} />
        <Route path="/landingpage" element={<Landingpage />} />
        <Route path="/" element={<Landingpage />} />
        <Route path="/comingsoon" element={<ComingLater />} />
        <Route path="/bookchoice" element={<Bcher />} />
        <Route path="/reading12option" element={<Reading12 />} />
        <Route path="/readingfreechoice/:bookId" element={<ReadingFreechoice />} />
        {/* Add additional routes here */}
      </Routes>
    </Router>
  );
}

export default App;
